import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarMedium = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.30238 11.6315C2.52393 11.8045 2.8049 11.745 3.13992 11.5019L5.99834 9.39992L8.86217 11.5019C9.19718 11.745 9.47275 11.8045 9.69969 11.6315C9.92124 11.464 9.96989 11.1885 9.83478 10.7994L8.70546 7.43306L11.5909 5.36355C11.926 5.12579 12.061 4.87183 11.9745 4.60706C11.8881 4.34229 11.6341 4.21262 11.2181 4.21802L7.67881 4.24503L6.60352 0.862475C6.47384 0.468029 6.27932 0.262695 5.99834 0.262695C5.72276 0.262695 5.52824 0.468029 5.39855 0.862475L4.32327 4.24503L0.784016 4.21802C0.367947 4.21262 0.113988 4.34229 0.0275381 4.60706C-0.0643229 4.87183 0.0761631 5.12579 0.411183 5.36355L3.29662 7.43306L2.1673 10.7994C2.03221 11.1885 2.08085 11.464 2.30238 11.6315Z",
		fill: "#C6C6C8"
	})]
});
const ForwardRef = forwardRef(SvgStarMedium);
export { ForwardRef as ReactComponent };
